<template>
  <el-table-column
    prop="email"
    sortable
    label="E-mail"
    show-overflow-tooltip
  >
    <template slot-scope="scope">
      {{ scope.row.email }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'email',
  };
</script>
